module.exports = __webpack_public_path__ + "static/ui-e7e9ac259d9bf1831aad9526df7f78bf.webp";